// extracted by mini-css-extract-plugin
module.exports = {"modal":"ModalOverlay_modal__VQm5y","slide-down":"ModalOverlay_slide-down__50rQw"};